import React from 'react';

function App() {
  return (
    <div style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "sans-serif",
      flexDirection: "column"
    }}>
      <h1>🚧 Site Under Construction</h1>
      <p>We’re building something awesome. Check back soon.</p>
    </div>
  );
}

export default App;
